import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getUserPermissions = createAsyncThunk('getUserPermissions', async () => {
    const response = await axios.get(`/user-permissions`);

    return response.data;
});
